export default function Archived() {
  return (
    <div
      className="status_card"
      style={{ border: "1px solid #EFF2F3", backgroundColor: "#F6F9F9" }}
    >
      <div className="titleBar">
        <img src="/images/potential-deals/status/archive.svg" alt="" />
      </div>
      <h5> Archived </h5>
      <h6> The proposal is now in history. </h6>
    </div>
  );
}
